<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_3"></a><a id="page_4">Copyright© 1964 Leo Bruce</a></p><a id="page_4">
<p class="copyright1">All rights reserved.</p>
<p class="copyright1">Printed and bound in the USA.</p>
<p class="copyright1">First American Paperback Edition 1983</p>
<p class="copyright2">Second printing 1988</p>
<p class="copyright1">Published by</p>
<p class="copyright3">Academy Chicago Publishers</p>
<p class="copyright3">425 North Michigan Avenue</p>
<p class="copyright3">Chicago, Illinois 60611</p>
<p class="copyright2">By arrangement with Charles Scribner’s Sons.</p>
<p class="copyright2">No part of this book may be reproduced<br/>in any form without the express<br/>written permission of the publisher.</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright1">Bruce, Leo, 1903-1980.</p>
<p class="copyright4">Death in Albert Park.</p>
<p class="copyright5">I. Title.</p>
<p class="copyright3">PR6005.R673D4 1979 823’.912 83-3748</p>
<p class="copyright3">ISBN 0-89733-073-0</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Copyright.vue?c051f4d2